import { useEffect, useState } from "react";
import { getAllCategorisAdmin } from "../services/api";

export default function useCategories() {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    getAllCategorisAdmin().then((data) => {
      setCategories(data);
    });
  }, []);

  return categories;
}
